<template>
    <v-container fill-height>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm6>
                <v-flex xs12>
                    <div class="text-xs-center ma-3">
                        <img src="/images/logo.png">
                    </div>
                </v-flex>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            <h3 class="headline mx-auto">Form Lupa Password</h3>
                        </v-card-title>
                        <v-card-actions>
                            <v-layout row>
                                <v-flex xs12>
                                    <form @submit.prevent="send">
                                        <v-text-field
                                                label="Email"
                                                name="form.email"
                                                v-model="form.email"
                                                :error-messages="email_errors"
                                                @blur="$v.form.email.$touch()"
                                                @input="$v.form.email.$touch()"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                label="Handphone"
                                                name="form.hp"
                                                v-model="form.hp"
                                                :error-messages="hp_errors"
                                                @blur="$v.form.hp.$touch()"
                                                @input="$v.form.hp.$touch()"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                label="Password Baru"
                                                name="form.password"
                                                v-model="form.password"
                                                :error-messages="password_errors"
                                                @blur="$v.form.password.$touch()"
                                                @input="$v.form.password.$touch()"
                                                :counter="20"
                                                min="6"
                                                :append-icon="password_visibility ? 'visibility' : 'visibility_off'"
                                                @click:append="() => (password_visibility = !password_visibility)"
                                                :type="password_visibility ? 'text' : 'password'"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                label="Konfirmasi Password Baru"
                                                name="form.password_confirmation"
                                                v-model="form.password_confirmation"
                                                :error-messages="password_confirmation_errors"
                                                @blur="$v.form.password_confirmation.$touch()"
                                                @input="$v.form.password_confirmation.$touch()"
                                                :counter="20"
                                                min="6"
                                                :append-icon="password_confirmation_visibility ? 'visibility' : 'visibility_off'"
                                                @click:append="() => (password_confirmation_visibility = !password_confirmation_visibility)"
                                                :type="password_confirmation_visibility ? 'text' : 'password'"
                                                required
                                        ></v-text-field>
                                        <v-layout row wrap align-center justify-center>
                                            <v-flex ma-2>
                                                <v-btn name="login" type="submit" block color="primary">Reset Password</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </form>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import UserAPI from "@/api/user";
    import {validationMixin} from 'vuelidate';
    import {required, sameAs} from 'vuelidate/lib/validators';
    import swal from 'sweetalert2';


    export default {
        mixins: [validationMixin],

        data: () => ({
            status: '',
            password_visibility: false,
            password_confirmation_visibility: false,
            form: {
                email: null,
                hp: null,
                password: null,
                password_confirmation: null,
            }
        }),
        validations: {
            form: {
                email: {required},
                hp: {required},
                password: {required},
                password_confirmation: {required,sameAsPassword: sameAs('password')},
            },
        },
        computed: {
            // computed
            email_errors() {
                const errors = [];
                if (!this.$v.form.email.$dirty) return errors;
                !this.$v.form.email.required && errors.push('Username harus diisi.');
                return errors;
            },

            // computed
            hp_errors() {
                const errors = [];
                if (!this.$v.form.hp.$dirty) return errors;
                !this.$v.form.hp.required && errors.push('Handphone harus diisi.');
                return errors;
            },

            password_errors() {
                const errors = [];
                if (!this.$v.form.password.$dirty) return errors;
                !this.$v.form.password.required && errors.push('Password harus diisi.');
                return errors;
            },

            password_confirmation_errors() {
                const errors = [];
                if (!this.$v.form.password_confirmation.$dirty) return errors;
                !this.$v.form.password_confirmation.required && errors.push('Konfirmasi password harus diisi.');
                !this.$v.form.password_confirmation.sameAsPassword && errors.push('Korfirmasi password tidak cocok dengan password baru');
                return errors;
            },
        },

        methods: {
            send() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {

                    this.$store.dispatch("loading/start");

                    UserAPI.doResetPassword({ data: this.form, reset_token: this.$route.params.id }).then(response => {
                        this.$store.dispatch("loading/stop");
                        swal.fire({
                            type: 'info',
                            title: response.data.results.message,
                            reverseButtons: false,
                            confirmButtonText: 'ok',
                        }).then(function () {
                            this.$router.push({name: 'login'});
                        }.bind(this));
                    });
                }
            }
        }
    }
</script>
